import React from 'react';
import { ClassNames } from '@emotion/core';
import Theme from './Theme';
import { StyledNavigation } from './Navigation/styles';

const { zIndex10 } = Theme.zIndex;

/**
 * HOC that fixes modal overlay scrolling.
 */
function withFixedOverlay(Component) {
  const WithFixedOverlay = ({
    onAfterClose,
    onAfterOpen,
    overlayCSS,
    overlayClassName,
    htmlOpenClassName,
    ...props
  }) => (
    <ClassNames>
      {({ css, cx }) => (
        <Component
          overlayClassName={cx(
            css`
              position: fixed;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: ${zIndex10};
              display: flex;
              overflow-y: scroll;
              background-color: rgba(0, 0, 0, 0.75);
              ${overlayCSS}
            `,
            overlayClassName
          )}
          htmlOpenClassName={cx(
            css`
              width: 100%;
              ${StyledNavigation} {
                position: relative;
              }
            `,
            htmlOpenClassName
          )}
          onAfterClose={() => {
            const { top } = document.documentElement.style;
            document.documentElement.style.position = null;
            window.scrollTo(0, Math.abs(parseInt(top, 10)));
            document.documentElement.style.top = null;
            document.documentElement.style.maxWidth = null;
            const header = document.querySelector(`${StyledNavigation}`);
            if (header) header.style.top = null;
            if (onAfterClose) onAfterClose();
          }}
          onAfterOpen={() => {
            const { scrollY } = window;
            const { clientWidth } = document.documentElement;
            document.documentElement.style.maxWidth = `${clientWidth}px`;
            document.documentElement.style.position = 'fixed';
            document.documentElement.style.top = `-${scrollY}px`;
            const header = document.querySelector(`${StyledNavigation}`);
            if (header) header.style.top = `${scrollY}px`;
            if (onAfterOpen) onAfterOpen();
          }}
          {...props}
        />
      )}
    </ClassNames>
  );
  WithFixedOverlay.displayName = `withFixedOverlay(${
    Component.displayName || Component.name || 'Component'
  })`;
  return WithFixedOverlay;
}

export default withFixedOverlay;
